import * as React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./sidebar.css";
import wtLogo from "../Images/Inside screen logo-01.svg";

function Sidebar() {
  const navigator = useNavigate();
  return (
    <>
      <div className="divSidebar">

        <aside>
          <div
            className="pt-[20px] mb-[45px] logo_link cursor-pointer"
            onClick={() => navigator("/secured/empDashboard")}
          >
            <img src={wtLogo} draggable="false"/>
          </div>
          <NavLink activeclassname="active" to={`/secured/empDashboard`}> Dashboard</NavLink>
          <NavLink activeclassname="active" to={`/secured/addTicket`}>Add Ticket </NavLink>
          <NavLink activeclassname="active" to={`/secured/ticketList`}> Ticket  List</NavLink>
          {/* <div ><a href="https://www.wishtreetech.com/" target="_blank">SLA</a></div> */}
        </aside>

      </div>
    </>



  );
}
export default Sidebar;
